<template>
  <q-page padding>
    <PageHeader
      title="Catálogo Ferramentas"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div
      class="row col-12 q-mt-md q-gutter-sm text-brand-5 text-weight-bold container-btn-cadastro items-center"
    >
      <div class="col-md-2 col-xs-6">
        <div class="texto-titulo-input">Unidade</div>
        <listaUnidadesSelect />
      </div>
      <div>
        <p></p>
        <router-link
          :to="{
            name: 'ferramentaria-cadastro-catalogo',
          }"
        >
          <q-btn
            color="positive"
            class="btn-cadastro q-mt-xs"
            no-caps
            label="Criar Novo"
            icon="add"
          />
        </router-link>
      </div>
    </div>
    <div class="container-tabela q-mt-xl">
      <div class="q-mt-xl q-mb-md">
        <ComponenteFiltros
          :codigo="true"
          :classCodigo="'col-md col-xs-6'"
          :descricao="true"
          :classDescricao="'col-md col-xs-5'"
          :classGrupo="'col-md col-xs-6'"
          :subgrupo="true"
          :classSubgrupo="'col-md col-xs-5'"
          @enviarFiltro="receberFiltro"
        />
      </div>
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        :columns="columns"
        :rows="listaFerramentas"
        :hide-bottom="!listaFerramentas.length == 0"
        flat
        dense
        table-header-class="bg-accent text-weight-bold"
        :grid="mobile"
        no-data-label="Nenhuma ferramenta encontrada."
        row-key="uuid"
        :class="{ 'my-sticky-dynamic': !mobile }"
        :rows-per-page-options="[0]"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs row col-md col-sm-6 col-xs-12">
            <q-card class="container-grid-table col">
              <div class="q-pa-sm">
                <div class="row col-12 container-imagem-grid">
                  <div
                    style="position: relative; width: 100%"
                    v-if="props.row.url"
                  >
                    <q-img
                      fit="contain"
                      height="240px"
                      width="100%"
                      no-native-menu
                      :src="props.row.url"
                    >
                    </q-img>
                    <div
                      style="width: 100%; bottom: 0; background: transparent"
                      class="absolute row col-12 justify-between items-center"
                    >
                      <q-icon
                        size="25px"
                        color="secondary"
                        class="absolute all-pointer-events row cursor"
                        style="bottom: 8px; left: 8px"
                        name="article"
                        :disable="disable"
                        @click="
                          (rightDrawerOpen = true),
                            (editarFerramentaDados = { ...props.row }),
                            (dadosEditar = { ...props.row })
                        "
                      ></q-icon>
                      <q-icon
                        class="absolute all-pointer-events cursor"
                        size="25px"
                        color="red"
                        style="bottom: 8px; right: 16px"
                        name="delete"
                        :disable="disable"
                        @click="
                          (ferramentaIdExcluir = props.row.uuid),
                            (confirm = true)
                        "
                      ></q-icon>
                    </div>
                  </div>
                  <q-img
                    v-else
                    fit="contain"
                    height="240px"
                    width="100%"
                    src="../../../assets/semImagem.jpg"
                  >
                    <div
                      style="width: 100%; bottom: 0; background: transparent"
                      class="absolute row col-12 justify-between items-center"
                    >
                      <q-icon
                        size="25px"
                        color="secondary"
                        class="absolute all-pointer-events row cursor"
                        style="bottom: 8px; left: 8px"
                        name="article"
                        :disable="disable"
                        @click="
                          (rightDrawerOpen = true),
                            (editarFerramentaDados = { ...props.row }),
                            (dadosEditar = { ...props.row })
                        "
                      ></q-icon>
                      <q-icon
                        class="absolute all-pointer-events cursor"
                        size="25px"
                        color="red"
                        style="bottom: 8px; right: 16px"
                        name="delete"
                        :disable="disable"
                        @click="
                          (ferramentaIdExcluir = props.row.uuid),
                            (confirm = true)
                        "
                      ></q-icon>
                    </div>
                  </q-img>
                </div>
              </div>
              <div class="row col-12 q-pa-sm q-gutter-xs">
                <div class="row col-12">
                  <span v-if="props.row?.codigo?.length < 25"
                    ><strong>Código: </strong>{{ props.row?.codigo }}</span
                  >
                  <span v-else
                    ><strong>Código: </strong
                    >{{ props.row?.codigo?.substring(0, 25) }}...
                    <q-tooltip>{{ props.row?.codigo }}</q-tooltip></span
                  >
                </div>
                <div class="row col-12">
                  <span v-if="props.row?.descricao?.length < 25"
                    ><strong>Descrição: </strong
                    >{{ props.row?.descricao }}</span
                  >
                  <span v-else
                    ><strong>Descrição: </strong
                    >{{ props.row?.descricao?.substring(0, 25) }}...
                    <q-tooltip>{{ props.row?.descricao }}</q-tooltip></span
                  >
                </div>
                <div class="row col-12">
                  <span
                    ><strong>Grupo: </strong>{{ props.row?.grupo?.nome }}</span
                  >
                </div>
                <div class="row col-12">
                  <span
                    ><strong>Subgrupo: </strong
                    >{{ props.row?.subgrupo?.nome }}</span
                  >
                </div>
              </div>
            </q-card>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body-cell-codigo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.codigo }}
          </q-td>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.descricao }}
          </q-td>
        </template>
        <template v-slot:body-cell-grupo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.grupo?.nome }}
          </q-td>
        </template>
        <template v-slot:body-cell-subgrupo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row?.subgrupo?.nome }}
          </q-td>
        </template>
        <template v-slot:body-cell-imagem="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <div
              style="
                border: 1px solid #707070;
                height: 60px;
                width: 60px;
                border-radius: 5px;
              "
            >
              <q-img
                v-if="props.row.url"
                fit="contain"
                height="100%"
                width="95%"
                :src="props.row.url"
              />
              <q-img
                v-else
                fit="contain"
                height="100%"
                width="95%"
                src="../../../assets/semImagem.jpg"
              />
            </div>
          </q-td>
        </template>
        <template v-slot:body-cell-detalhe="props">
          <q-td :props="props">
            <q-btn
              icon="article"
              outline
              color="blue"
              round
              flat
              :disable="disable"
              @click="
                (rightDrawerOpen = true),
                  (editarFerramentaDados = { ...props.row }),
                  (dadosEditar = { ...props.row })
              "
            />
          </q-td>
        </template>
        <template v-slot:body-cell-excluir="props">
          <q-td :props="props">
            <q-btn
              icon="delete"
              color="red"
              round
              flat
              :disable="disable"
              @click="(ferramentaIdExcluir = props.row.uuid), (confirm = true)"
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          :size="mobile ? 'md' : 'sm'"
        />
      </div>
    </div>
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerOpen" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center justify-between">
            <div class="row items-center">
              <q-icon
                style="cursor: pointer"
                :name="tab === 'inicio' ? 'close' : 'arrow_back_ios'"
                class="q-mr-md icon-modal"
                @click="
                  tab === 'inicio'
                    ? (rightDrawerOpen = false)
                    : (tab = 'inicio')
                "
              />
              <span class="texto-titulo-modal">
                <span>
                  <span>
                    {{
                      tab === "inicio"
                        ? "Editar Ferramenta"
                        : tab === "atributo"
                        ? "Adicionar Atributos"
                        : tab === "checklist"
                        ? "Adicionar Checklist"
                        : tab === "acessorios"
                        ? "Adicionar Acessórios"
                        : ""
                    }}
                  </span>
                </span>
              </span>
            </div>
            <div
              v-if="tab !== 'checklist'"
              class="justify-end row col-md-12 col-lg-12 col-xs-12 q-mt-xs"
            >
              <div class="row col-12 col-xs-12 container-tab justify-end">
                <q-tabs v-model="tab" narrow-indicator dense align="right">
                  <q-tab
                    class="text-black"
                    no-caps
                    name="atributo"
                    label="Atributos"
                  />
                  <q-tab
                    no-caps
                    class="text-black"
                    name="checklist"
                    label="Checklist"
                    @click="subTab = 'associar'"
                  />
                  <q-tab
                    no-caps
                    class="text-black"
                    name="acessorios"
                    label="Acessórios"
                  />
                </q-tabs>
              </div>
            </div>
            <div v-else class="row col-xs-12 col-md-2 col-lg-2 justify-end">
              <div class="row col-2 justify-end container-tab">
                <q-tabs v-model="subTab" narrow-indicator dense align="right">
                  <q-tab
                    class="text-black"
                    no-caps
                    name="associar"
                    label="Associar"
                  />
                  <q-tab
                    class="text-black"
                    no-caps
                    name="adicionar"
                    label="Adicionar"
                  />
                </q-tabs>
              </div>
            </div>
          </div>
        </div>
        <q-scroll-area v-if="tab === 'inicio'" style="width: 100%; height: 85%">
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 90%"
          >
            <div class="q-px-md text-weight-bold">
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Código</div>
                <q-input
                  class="input-modal"
                  v-model="editarFerramentaDados.codigo"
                  dense
                  maxlength="50"
                  outlined
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Descrição</div>
                <q-input
                  class="input-modal"
                  v-model="editarFerramentaDados.descricao"
                  dense
                  maxlength="255"
                  outlined
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Unidade Medida</div>
                <q-input
                  v-model="editarFerramentaDados.unidadeMedida"
                  dense
                  maxlength="10"
                  class="input-modal"
                  outlined
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">
                  Tempo de Permanencia
                </div>
                <q-input
                  v-model="editarFerramentaDados.tempoPermanencia"
                  dense
                  class="input-modal"
                  outlined
                  type="number"
                  min="1"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Grupo</div>
                <SelecaoGrupo
                  :grupoUuid="
                    editarFerramentaDados?.subgrupo?.catalogoGrupoUuid
                  "
                  :model="editarFerramentaDados?.grupo"
                  @enviarGrupo="receberGrupo"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Sub Grupo</div>
                <SelecaoSubgrupo
                  :grupoUuid="grupo?.catalogoGrupoUuid"
                  :model="editarFerramentaDados?.subgrupo"
                  @enviarSubgrupo="receberSubgrupo"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Imagem</div>
                <div style="position: relative" class="container-imagem">
                  <q-img
                    class="imagem-ferramenta"
                    fit="contain"
                    :src="editarFerramentaDados.url"
                  >
                    <div class="file-container">
                      <q-file
                        style="width: 100% !important; height: 200px"
                        borderless
                        type="file"
                        v-model="img"
                      >
                        <div
                          class="row col-12 justify-center items-center file"
                        >
                          <span
                            v-if="
                              editarFerramentaDados.url == null ||
                              editarFerramentaDados.url == ''
                            "
                            class="texto-alterar-imagem"
                            >{{
                              editarFerramentaDados.url == null ||
                              editarFerramentaDados.url == ""
                                ? "Adicionar Imagem"
                                : ""
                            }}</span
                          >
                        </div>
                      </q-file>
                    </div>
                  </q-img>
                  <div
                    v-if="
                      editarFerramentaDados.url != '' &&
                      img?.name == undefined &&
                      editarFerramentaDados.url != imageUrl &&
                      editarFerramentaDados.url != null
                    "
                    style="
                      width: 100%;
                      top: 0;
                      background: transparent;
                      cursor: pointer;
                    "
                    class="absolute row col-12 justify-between items-center"
                    @click="excluirImagem()"
                  >
                    <q-icon
                      class="absolute all-pointer-events"
                      size="25px"
                      color="red"
                      style="top: 8px; right: 16px; z-index: 30"
                      name="delete"
                    ></q-icon>
                  </div>
                </div>
              </div>
            </div>
            <div class="q-px-md q-mt-md q-pb-md btn-editar-container">
              <q-btn
                class="q-mt-sm btn-modal"
                icon="check_circle_outlined"
                label="Salvar"
                no-caps
                color="positive"
                @click="editarFerramenta()"
              />
            </div>
          </div>
        </q-scroll-area>
        <q-scroll-area
          v-if="tab === 'checklist'"
          style="max-width: 100%; height: 85%"
        >
          <div
            class="row col-12"
            style="height: 100%"
            v-if="subTab === 'associar'"
          >
            <div class="q-px-md col-12 text-weight-bold q-mb-md">
              <div class="row col-12 q-mt-xs items-center q-mb-lg">
                <div class="col">
                  <div class="texto-titulo-input q-mb-xs">Checklist</div>
                  <SelecaoChecklist
                    @enviarChecklist="receberChecklist"
                    :multiple="false"
                    :resetar="resetarChecklist"
                  />
                </div>
                <div>
                  <p></p>
                  <q-btn
                    icon="add"
                    flat
                    class="q-mt-xs q-ml-sm"
                    round
                    color="primary"
                    :disable="disableChecklist"
                    @click="associarChecklist(checklist?.checkListUuid)"
                  />
                </div>
              </div>
              <div>
                <div class="texto-titulo-tabela">
                  Lista de Checklist Associados
                </div>
                <div
                  v-for="(checklist, index) in listaChecklist"
                  :key="index"
                  class="row q-mt-xs q-pa-sm items-center justify-between"
                  style="border: 1px solid; border-radius: 5px"
                >
                  <div
                    style="
                      width: 80%;
                      word-wrap: break-word;
                      word-break: break-all;
                    "
                  >
                    <span class="row col-12 texto-conteudo-tabela">
                      {{ index + 1 }} - {{ checklist.nome }}
                    </span>
                  </div>
                  <div>
                    <q-btn
                      icon="close"
                      dense
                      flat
                      round
                      color="red"
                      class="q-ml-sm icon-tabela"
                      :disable="disableChecklist"
                      @click="desassociarChecklist(checklist.checkListUuid)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 90%"
            v-if="subTab === 'adicionar'"
          >
            <div class="q-px-md text-weight-bold">
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Nome</div>
                <q-input
                  class="input-modal"
                  v-model="checklistCriar.nome"
                  dense
                  :rules="[validacaoCaracteresChecklist]"
                  hide-bottom-space
                  outlined
                  maxlength="255"
                />
              </div>
            </div>
            <div class="q-px-md q-mt-md q-pb-md btn-editar">
              <q-btn
                class="q-mt-sm btn-modal"
                icon="check_circle_outlined"
                label="Criar"
                no-caps
                color="positive"
                @click="criarChecklist()"
              />
            </div>
          </div>
        </q-scroll-area>
        <q-scroll-area
          v-if="tab === 'atributo'"
          style="width: 100%; height: 85%"
        >
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 90%"
          >
            <div class="q-px-md text-weight-bold">
              <div class="row col-md-12 q-mt-xs q-mb-lg">
                <div class="col-md-3 col-xs">
                  <div class="texto-titulo-input q-mb-xs">Chave</div>
                  <q-input
                    class="input-modal"
                    v-model="dadoAtributo[0].chave"
                    dense
                    :rules="[validacaoCaracteresEspeciais]"
                    hide-bottom-space
                    outlined
                  />
                </div>
                <div class="col-md col-xs-4 q-ml-xs">
                  <div class="texto-titulo-input q-mb-xs">Valor</div>
                  <q-input
                    class="input-modal"
                    v-model="dadoAtributo[0].valor"
                    dense
                    :rules="[validacaoCaracteresEspeciais]"
                    hide-bottom-space
                    outlined
                  />
                </div>
                <div>
                  <q-btn
                    icon="add"
                    dense
                    flat
                    round
                    color="primary"
                    :disable="disableAtributo"
                    class="q-ml-sm icon"
                    @click="adicionarAtributo()"
                  />
                </div>
              </div>
              <div>
                <div class="texto-titulo-tabela">
                  Lista de Atributos Criados
                </div>
                <div
                  v-for="(atributo, index) in atributosFerramentas"
                  :key="index"
                  class="row col-md-12 q-mt-xs q-pa-sm items-center"
                  style="border: 1px solid; border-radius: 5px"
                >
                  <div class="col-10">
                    <div
                      class="row col-12 justify-between texto-conteudo-tabela"
                      style="
                        word-wrap: break-all;
                        width: 90%;
                        word-break: break-all;
                      "
                    >
                      <span class="col"
                        >{{ index + 1 }}- <strong>Chave:</strong>
                        {{ atributo.chave }}</span
                      >
                      <span class="col"
                        ><strong class="q-mr-xs">Valor:</strong>
                        {{ atributo.valor }}</span
                      >
                    </div>
                  </div>
                  <div>
                    <q-btn
                      icon="close"
                      dense
                      flat
                      round
                      color="red"
                      class="q-ml-sm"
                      :disable="disableAtributo"
                      @click="excluirAtributo(atributo.chave)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-scroll-area>
        <q-scroll-area
          v-if="tab === 'acessorios'"
          style="width: 100%; height: 85%"
        >
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 90%"
          >
            <div class="q-px-md text-weight-bold">
              <div class="row col-md-12 q-mt-xs q-mb-lg">
                <div class="col-md col-xs">
                  <div class="texto-titulo-input q-mb-xs">Nome</div>
                  <q-input
                    class="input-modal"
                    v-model="dadoAcessorio[0].nome"
                    dense
                    :rules="[validacaoCaracteresEspeciais]"
                    hide-bottom-space
                    outlined
                  />
                </div>
                <div>
                  <q-btn
                    icon="add"
                    dense
                    flat
                    round
                    color="primary"
                    :disable="disableAcessorio"
                    class="q-ml-sm icon"
                    @click="adicionarAcessorio()"
                  />
                </div>
              </div>
              <div>
                <div class="texto-titulo-tabela">
                  Lista de Acessórios Criados
                </div>
                <div
                  v-for="(acessorio, index) in acessorioFerramenta"
                  :key="index"
                  class="row col-md-12 q-mt-xs q-pa-sm items-center"
                  style="border: 1px solid; border-radius: 5px"
                >
                  <div class="col-10">
                    <div
                      class="row col-12 justify-between texto-conteudo-tabela"
                      style="
                        width: 90%;
                        word-wrap: break-all;
                        word-break: break-all;
                      "
                    >
                      <span class="col"
                        >{{ index + 1 }}- <strong>Nome:</strong>
                        {{ acessorio.nome }}</span
                      >
                    </div>
                  </div>
                  <div>
                    <q-btn
                      icon="close"
                      dense
                      flat
                      round
                      color="red"
                      class="q-ml-sm"
                      :disable="disableAcessorio"
                      @click="excluirAcessorio(acessorio.uuid)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-scroll-area>
      </q-card>
    </Transition>
    <q-dialog v-model="confirm" persistent>
      <q-card
        class="q-pa-sm container-modal-excluir text-brand-5 text-weight-bolder q-pa-xl"
      >
        <q-card-section class="row col-12 justify-center">
          <span class="texto-excluir-pai">TEM CERTEZA QUE DESEJA EXCLUIR?</span>
          <span class="texto-excluir-filho text-brand-5 q-mt-md q-mb-lg">
            Ao clicar em Excluir você estará deletando por definitivo o item do
            catálogo</span
          >
        </q-card-section>

        <div class="row col-12 justify-center">
          <q-btn
            no-caps
            label="Excluir"
            color="positive"
            v-close-popup
            class="btn-excluir"
            icon="check_circle_outline"
            @click="excluirFerramenta()"
          />
          <q-btn
            icon="cancel"
            no-caps
            label="Cancelar"
            color="negative"
            class="btn-excluir q-ml-md"
            v-close-popup
          />
        </div>
      </q-card>
    </q-dialog>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </q-page>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelecaoGrupo from "../components/SelecaoGrupo.vue";
import SelecaoSubgrupo from "../components/SelecaoSubgrupo.vue";
import SelecaoChecklist from "../components/SelecaoChecklist.vue";
import ComponenteFiltros from "../components/ComponenteFiltros.vue";
import PageHeader from "../../../components/PageHeader.vue";

const columns = [
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
  },
  {
    name: "subgrupo",
    label: "Sub grupo",
    align: "left",
  },
  {
    name: "imagem",
    label: "Imagem",
    align: "left",
  },
  {
    name: "detalhe",
    label: "Detalhe",
    align: "center",
  },
  {
    name: "excluir",
    label: "Excluir",
    align: "center",
  },
];
export default {
  components: {
    ListaUnidadesSelect,
    SelecaoGrupo,
    SelecaoSubgrupo,
    SelecaoChecklist,
    ComponenteFiltros,
    PageHeader,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const catalogoUuid = salvarCatalogoUuid();
    const listaFerramentas = ref([]);
    let rightDrawerOpen = ref(false);
    const editarFerramentaDados = ref({});
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let disable = ref(false);
    let loading = ref(false);
    let disableAtributo = ref(false);
    let disableChecklist = ref(false);
    const imageUrl = ref("");
    const img = ref(null);
    let confirm = ref(false);
    const ferramentaIdExcluir = ref("");
    const atributosFerramentas = ref([{ chave: "", valor: "" }]);
    const options = ref({
      checklist: [],
    });
    const tab = ref("inicio");
    const subTab = ref("associar");
    const dadoAtributo = ref([{ chave: "", valor: "" }]);
    const dadoAcessorio = ref([{ nome: "" }]);
    const listaChecklist = ref([]);
    const checklist = ref({ checkListUuid: "" });
    const checklistCriar = ref({ nome: "", descricao: "" });
    const resetarChecklist = ref(0);
    const filtros = ref({});
    const urlImagem = ref("");
    const grupo = ref({});
    const subGrupo = ref({ catalogoSubGrupoUuid: null });
    const dadosEditar = ref({});
    let disableAcessorio = ref(false);
    const acessorioFerramenta = ref([]);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarFerramentas = async (page = 1, rowsPerPage = 10) => {
      if (catalogoUuid.catalogoUuid.value === null) {
        listaFerramentas.value = [];
        return;
      }
      disable.value = true;
      loading.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarFerramentas",
          {
            perPage: rowsPerPage,
            page: page,
            codigo: filtros.value?.codigo,
            catalogoUuid: catalogoUuid.catalogoUuid.value,
            catalogoSubGrupoUuid: filtros.value.subgrupo?.catalogoSubGrupoUuid,
            nome: filtros.value?.descricao,
            nomeGrupo: filtros.value?.grupo?.nome,
            nomeSubgrupo: filtros.value?.grupo?.nome
              ? filtros.value?.subgrupo?.nome
              : "",
          }
        );
        listaFerramentas.value = response.listaFerramentas;
        pagination.value.page = response.response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.response.data.resultado.total;
        pagination.value.rowsPerPage = response.response.data.resultado.perPage;
        disable.value = false;
        loading.value = false;
      } catch (error) {
        console.log(error);
        disable.value = false;
        loading.value = false;
      }
    };

    const receberGrupoFiltro = (value) => {
      if (value === null || value === undefined) {
        filtros.value.grupo = "";
        return;
      }
      filtros.value.grupo = value;
    };

    const receberSubgrupoFiltro = (value) => {
      if (value === null || value === undefined) {
        filtros.value.subgrupo = "";
        return;
      }
      filtros.value.subgrupo = value;
    };

    const listarAtributoItem = async () => {
      disableAtributo.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarAtributoItem",
          {
            catalogoItemUuid: editarFerramentaDados.value.uuid,
          }
        );
        atributosFerramentas.value = response.response.data.resultado.dados;
        disableAtributo.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const listarAcessorioItem = async () => {
      disableAcessorio.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarAcessorioItem",
          {
            catalogoItemUuid: editarFerramentaDados.value.uuid,
          }
        );
        acessorioFerramenta.value = response.response.data.resultado.dados;
        disableAcessorio.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const excluirAtributo = async (chaveAtributo) => {
      try {
        await store.dispatch("ferramentaria/excluirAtributoItem", {
          catalogoItemUuid: editarFerramentaDados.value.uuid,
          chaveAtributo,
        });
        listarAtributoItem();
        quasar.notify({
          message: "Atributo excluido com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao excluir atributo.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const excluirAcessorio = async (uuidAcessorio) => {
      try {
        await store.dispatch("ferramentaria/excluirAcessorioItem", {
          uuidAcessorio,
        });
        listarAcessorioItem();
        quasar.notify({
          message: "Acessório excluido com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao excluir acessório.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const adicionarAtributo = async () => {
      if (
        validacaoCaracteresEspeciais(dadoAtributo.value[0].chave) != true ||
        validacaoCaracteresEspeciais(dadoAtributo.value[0].valor) != true
      ) {
        return;
      }
      disableAtributo.value = true;
      try {
        await store.dispatch("ferramentaria/adicionarAtributoItem", {
          catalogoItemUuid: editarFerramentaDados.value.uuid,
          atributos: dadoAtributo.value,
        });
        listarAtributoItem();
        resetVariaveisAtributo();
        quasar.notify({
          message: "Atributo criado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disableAtributo.value = false;
      } catch (error) {
        quasar.notify({
          message: error.response.data.erros.mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disableAtributo.value = false;
      }
    };

    const resetVariaveisAtributo = () => {
      dadoAtributo.value = [{ chave: "", valor: "" }];
    };

    const resetVariaveisAcessorio = () => {
      dadoAcessorio.value = [{ nome: "" }];
    };

    const receberChecklist = (value) => {
      checklist.value = value;
    };

    const associarChecklist = async (checkListUuid) => {
      if (checkListUuid === "" || checkListUuid === undefined) {
        quasar.notify({
          message: "Selecione um checklist para associar.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      disableChecklist.value = true;
      try {
        await store.dispatch("ferramentaria/associarCheckListItem", {
          catalogoItemUuid: editarFerramentaDados.value.uuid,
          checklListUuid: checkListUuid,
        });
        quasar.notify({
          message: "Checklist associado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarChecklistItem();
        resetarChecklist.value++;
      } catch (error) {
        disableChecklist.value = false;
        if (error.response?.data?.erros?.mensagem) {
          quasar.notify({
            message: error.response?.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (
          error.response?.data?.erro?.mensagem ==
          `O checklist [${checkListUuid}] já está associado a este item [${editarFerramentaDados.value.uuid}].`
        ) {
          quasar.notify({
            message: `O Checklist: ${checklist.value.nome} já esta associado a ferramenta.`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        if (error.response?.data?.erro?.mensagem) {
          quasar.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        disableChecklist.value = false;
      }
    };

    const desassociarChecklist = async (checklListUuid) => {
      disableChecklist.value = true;
      try {
        await store.dispatch("ferramentaria/desassociarCheckListItem", {
          catalogoItemUuid: editarFerramentaDados.value.uuid,
          checklListUuid: checklListUuid,
        });
        quasar.notify({
          message: "Checklist desassociado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        checklist.value = "";
        listarChecklistItem();
      } catch (error) {
        disableChecklist.value = false;
        if (error.response.data.erros.mensagem) {
          quasar.notify({
            message: error.response?.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response.data?.erro?.mensagem) {
          quasar.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const listarChecklistItem = async () => {
      disableChecklist.value = true;
      try {
        const response = await store.dispatch("ferramentaria/listarChecklist", {
          catalogoUuid: catalogoUuid.catalogoUuid.value,
          per_page: 5,
          page: 1,
          catalogoItemUuid: editarFerramentaDados.value.uuid,
        });
        listaChecklist.value = response.data.resultado.dados;
        disableChecklist.value = false;
      } catch (error) {
        disableChecklist.value = false;
        console.log(error);
      }
    };

    const validacaoCaracteresChecklist = (val) => {
      const regex = /^[a-zA-ZÀ-ÖØ-öØ-ÿ?Çç\s]*$/;

      if (!regex.test(val)) {
        return "Caracteres especiais não são permitidos.";
      } else {
        return true;
      }
    };

    const criarChecklist = async () => {
      if (validacaoCaracteresChecklist(checklistCriar.value.nome) != true) {
        return;
      }
      if (checklistCriar.value.nome === "") {
        quasar.notify({
          message: "O nome é obrigatório.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch(
          "ferramentaria/adicionarChecklist",
          {
            catalogoUuid: catalogoUuid.catalogoUuid.value,
            nome: checklistCriar.value.nome,
            descricao: checklistCriar.value.nome,
            usuarioId: store.state.autenticacao.usuarioLogado.id,
            usuarioNome: store.state.autenticacao.usuarioLogado.nome,
          }
        );
        quasar.notify({
          message: "Checklist criado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        resetVariaveisChecklistCriar();
        associarChecklist(response.data.resultado.checkListUuid);
      } catch (error) {
        if (error.response?.data?.erros.mensagem) {
          quasar.notify({
            message: error.response.data.erros.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error?.response?.data?.erro?.mensagem) {
          quasar.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const editarFerramenta = async () => {
      if (editarFerramentaDados.value.codigo === "") {
        quasar.notify({
          message: "O campo código não pode estar vazio.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (editarFerramentaDados.value.descricao === "") {
        quasar.notify({
          message: "O campo descrição não pode estar vazio.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (editarFerramentaDados.value.unidadeMedida === "") {
        quasar.notify({
          message: "O campo unidade de medida não pode estar vazio.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        subGrupo.value?.catalogoSubGrupoUuid === "" ||
        subGrupo.value?.catalogoSubGrupoUuid === undefined
      ) {
        quasar.notify({
          message: "O campo subgrupo não pode estar vazio.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (img.value?.name != "" && img.value?.name != undefined) {
        await fazerUploadImagem();
      }
      try {
        await store.dispatch("ferramentaria/editarItem", {
          catalogoItemUuid: editarFerramentaDados.value.uuid,
          codigo:
            editarFerramentaDados.value.codigo === dadosEditar.value.codigo
              ? undefined
              : editarFerramentaDados.value.codigo,
          nome:
            editarFerramentaDados.value.descricao ===
            dadosEditar.value.descricao
              ? undefined
              : editarFerramentaDados.value.descricao,
          unidadeMedida: editarFerramentaDados.value.unidadeMedida,
          urlImagem: urlImagem.value || undefined,
          tempoPermanencia: parseInt(
            editarFerramentaDados.value.tempoPermanencia
          ),
          catalogoSubGrupoUuid:
            editarFerramentaDados.value.subgrupo.catalogoSubGrupoUuid ||
            undefined,
        });
        quasar.notify({
          message: "Ferramenta editada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarFerramentas();
        rightDrawerOpen.value = false;
      } catch (error) {
        if (error.response.data.erros.mensagem) {
          quasar.notify({
            message: error.response.data.erros.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (
          error.response.data?.erro?.mensagem &&
          error.response.data?.erro?.mensagem !=
            "Solicitacao incorreta, verifique 'detalhes' para mais informacao"
        ) {
          quasar.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const excluirFerramenta = async () => {
      try {
        await store.dispatch("ferramentaria/excluirItem", {
          catalogoItemUuid: ferramentaIdExcluir.value,
        });
        quasar.notify({
          message: "Ferramenta excluída com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarFerramentas();
      } catch (error) {
        if (error.response.data.erros?.mensagem) {
          quasar.notify({
            message: error.response.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response.data.erro?.mensagem) {
          quasar.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const excluirImagem = async () => {
      try {
        await store.dispatch("ferramentaria/excluirImagemItem", {
          catalogoItemUuid: editarFerramentaDados.value.uuid,
        });
        editarFerramentaDados.value.url = "";
        listarFerramentas();
      } catch (error) {
        console.log(error);
      }
    };

    const validacaoCaracteresEspeciais = (val) => {
      const regex = /[^a-zA-Z0-9\s]/g; // Expressão regular para caracteres especiais

      if (regex.test(val)) {
        return "Caracteres especiais não são permitidos.";
      } else {
        return true; // Validação passou
      }
    };

    const resetVariaveisChecklistCriar = () => {
      checklistCriar.value = {
        nome: "",
      };
    };

    const receberFiltro = (value) => {
      filtros.value = value;
      listarFerramentas();
    };

    const resetVariaveisModal = () => {
      atributosFerramentas.value = [];
      listaChecklist.value = [];
      editarFerramentaDados.value = {};
      img.value = null;
      imageUrl.value = "";
      tab.value = "inicio";
      checklistCriar.value = {
        nome: "",
        descricao: "",
      };
      atributosFerramentas.value = [
        {
          chave: "",
          valor: "",
        },
      ];
      checklist.value = "";
      urlImagem.value = "";
      grupo.value = {};
      subGrupo.value = { catalogoSubGrupoUuid: null };
    };

    const fazerUploadImagem = async () => {
      try {
        const response = await store.dispatch(
          "ferramentaria/receberUrlUpload",
          {
            catalogoItemUuid: editarFerramentaDados.value.uuid,
            nomeArquivo: img.value.name,
          }
        );

        let formAttributes =
          response.response.data.resultado.dados.formAttributes;
        let formInputs = response.response.data.resultado.dados.formInputs;
        const formData = new FormData();

        for (let input in formInputs) {
          formData.append(input, formInputs[input]);
        }

        formData.append("file", img.value);
        var request = new XMLHttpRequest();
        request.open(formAttributes.method, formAttributes.action);
        request.send(formData);
        urlImagem.value = `${formAttributes.action}/${formInputs.key}`;
      } catch (error) {
        console.log(error);
      }
    };

    const receberGrupo = (value) => {
      grupo.value = value;
    };

    const receberSubgrupo = (value) => {
      editarFerramentaDados.value.subgrupo = value;
    };

    const adicionarAcessorio = async () => {
      if (validacaoCaracteresEspeciais(dadoAcessorio.value[0].nome) != true) {
        return;
      }
      try {
        await store.dispatch("ferramentaria/adicionarAcessorioItem", {
          catalogoItemUuid: editarFerramentaDados.value.uuid,
          acessorios: dadoAcessorio.value,
        });
        listarAcessorioItem();
        resetVariaveisAcessorio();
        quasar.notify({
          message: "Acessório adicionado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        if (error.response.data.erros?.mensagem) {
          quasar.notify({
            message: error.response.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response.data.erro?.mensagem) {
          quasar.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    watch(
      () => img.value,
      () => {
        if (img.value == null) {
          return;
        }
        if (img.value == null || !img.value.type.includes("image")) {
          quasar.notify({
            message: "Selecione uma imagem",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          img.value = null;
          return;
        }
        let fileReader = new FileReader();
        fileReader.readAsDataURL(img.value);
        fileReader.addEventListener("load", () => {
          imageUrl.value = fileReader.result;
          editarFerramentaDados.value.url = fileReader.result;
        });
      }
    );

    watch(
      () => img.value,
      () => {
        if (editarFerramentaDados.value.url != null && img.value.name) {
          editarFerramentaDados.value.url = "";
        }
      }
    );

    watch(
      () => rightDrawerOpen.value,
      () => {
        if (rightDrawerOpen.value == false) {
          resetVariaveisModal();
          return;
        }
        listarAtributoItem();
        listarChecklistItem();
        listarAcessorioItem();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarFerramentas(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => catalogoUuid.catalogoUuid.value,
      () => {
        listarFerramentas();
      }
    );

    watch(
      () => editarFerramentaDados?.value?.tempoPermanencia,
      (atual, antigo) => {
        if (atual?.length > 6 && antigo?.length == 6) {
          quasar.notify({
            message: `O campo "Tempo de Permanência" não pode ter mais que 6 digitos.`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          editarFerramentaDados.value.tempoPermanencia = antigo;
        }
      }
    );

    onMounted(() => {
      listarFerramentas();
    });

    return {
      columns,
      listarFerramentas,
      listaFerramentas,
      rightDrawerOpen,
      validacaoCaracteresChecklist,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      img,
      imageUrl,
      confirm,
      ferramentaIdExcluir,
      subTab,
      atributosFerramentas,
      options,
      disable,
      tab,
      listarAtributoItem,
      receberGrupoFiltro,
      receberSubgrupoFiltro,
      excluirAtributo,
      disableAtributo,
      disableChecklist,
      adicionarAtributo,
      dadoAtributo,
      editarFerramenta,
      receberChecklist,
      listarChecklistItem,
      listaChecklist,
      associarChecklist,
      checklist,
      desassociarChecklist,
      checklistCriar,
      resetarChecklist,
      resetVariaveisModal,
      criarChecklist,
      excluirFerramenta,
      editarFerramentaDados,
      validacaoCaracteresEspeciais,
      filtros,
      fazerUploadImagem,
      urlImagem,
      excluirImagem,
      loading,
      grupo,
      subGrupo,
      receberGrupo,
      receberSubgrupo,
      catalogoUuid,
      listarAcessorioItem,
      acessorioFerramenta,
      disableAcessorio,
      dadoAcessorio,
      adicionarAcessorio,
      excluirAcessorio,
      resetVariaveisAcessorio,
      dadosEditar,
      mobile,
      receberFiltro,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
.input {
  width: 180px;
}
tbody tr .coluna-btn {
  width: 120px;
}
.my-sticky-dynamic {
  max-height: 500px;
}
.container-tabela {
  margin-top: 10px;
}
tbody tr td {
  white-space: pre-wrap;
}
.input-filtro-container {
  margin-top: 29px;
}
container {
  height: 100%;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 30;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
a {
  text-decoration: none;
}
input[type="file"] {
  display: none;
}
.imagem-ferramenta-container {
  border: 1px solid black;
}
.imagem-ferramenta {
  width: 100%;
  height: 200px;
}
.container-imagem {
  height: 210px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #707070;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}
.file-container {
  width: 100%;
  background: transparent;
  z-index: 30 !important;
}
.texto-alterar-imagem {
  color: black !important;
  z-index: 31;
  cursor: pointer;
  transition: all 0.5s;
}
.texto-alterar-imagem:hover {
  transform: scale(1.2);
}
.texto-excluir-pai {
  text-align: center;
  text-justify: inter-word;
  font-size: 23px;
  font-weight: bold;
  color: black;
}
.texto-excluir-filho {
  text-align: center;
  text-justify: inter-word;
  font-size: 15px;
}
.btn-excluir {
  font-size: 16px;
  padding: 0px 25px;
}
.icon {
  margin-top: 26px;
}
.espaco {
  margin-top: 1px;
}
.texto-titulo-modal {
  font-size: 16px;
}
.file {
  height: 180px;
}
.container-grid-table {
  border: 1px solid black;
  font-size: 12px;
}
.container-imagem-grid {
  border: 1px solid black;
  border-radius: 5px;
}
.tab-mobile {
  font-size: 1px !important;
}
.icon-modal {
  font-size: 22px;
}
.container-modal-excluir {
  width: 590px;
}
.texto-titulo-tabela {
  font-size: 14px;
  margin-bottom: 10px;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
  .btn-editar-container {
    margin-bottom: 20px;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
  .btn-editar-container {
    margin-bottom: 20px;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
  .btn-editar-container {
    margin-bottom: 20px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 100%;
    height: 85%;
    overflow: hidden;
    top: 103px;
    width: 340px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .container-btn-cadastro {
    margin: 17px 0px 0px 0px;
  }
  .btn-cadastro {
    font-size: 13px;
  }
  .container-tab {
    margin: 10px 0px 0px 0px;
  }
  .icon-modal {
    font-size: 19px;
    margin-right: 3px;
  }
  .texto-titulo-modal {
    font-size: 14px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .input-modal {
    font-size: 12px;
  }
  .btn-modal {
    font-size: 13px;
  }
  .imagem-ferramenta {
    width: 100%;
    height: 150px;
  }
  .container-imagem {
    height: 150px;
  }
  .texto-alterar-imagem {
    font-size: 10px;
  }
  .file {
    height: 120px;
  }
  .btn-editar-container {
    margin-bottom: 20px;
  }
  .input-mobile {
    font-size: 12px;
  }
  .container-modal-excluir {
    width: 100%;
    height: 250px;
    padding: 10px 10px 0px 10px;
    margin: 0px;
    border-radius: 10px;
  }
  .texto-excluir-pai {
    font-size: 17px;
  }
  .texto-excluir-filho {
    font-size: 14px;
  }
  .btn-excluir {
    font-size: 14px;
  }
  .texto-titulo-tabela {
    font-size: 13px;
    margin-bottom: 10px;
  }
  .texto-conteudo-tabela {
    font-size: 12px;
    max-width: 80%;
    word-wrap: break-word;
  }
  .icon-tabela {
    font-size: 12px;
  }
  .imagem-ferramenta {
    width: 100%;
    height: 150px;
  }
}
</style>
